import React from 'react';
import './AntdBtn.css';
import {  Button } from "antd";

export const AntdBtn = ({children, ...props}) => {
  return <Button {...props}>
    {children}
  </Button>
}
